import { HeadlessFormProvider } from '@delmonicos/shared-design-system-react/src/contexts/headless-form.provider';
import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { GetChannelsPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/inputs/get-channels-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useFilterSearchChannelListContext } from '../../channel-list.context';
import { ChannelListFilterSearchFormStep1Controller } from '../channel-list-filter-search-form-step-1/channel-list-filter-search-form-step-1.controller';

export interface ChannelListFilterSearchFormControllerProps {
  onError: SubmitErrorHandler<GetChannelsPaginatedModel>;
  onSubmit: SubmitHandlerWithDirtyFields<GetChannelsPaginatedModel>;
  onCancel: () => void;
}

export const ChannelListFilterSearchFormController = (
  props: ChannelListFilterSearchFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel } = props;
  const data = useFilterSearchChannelListContext();

  return (
    <HeadlessFormProvider<GetChannelsPaginatedModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      item={{
        fields: ['textToSearch'],
        component: <ChannelListFilterSearchFormStep1Controller />,
      }}
    />
  );
};
